module.exports = __webpack_public_path__ + "img/ic_wind_ori.a93080e5.png";